/**
 * Coid 2.0 server
 * Coid 2.0 server API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum EmployeePermissionType {
    AUTHORIZED_SIGNATORY = 'AUTHORIZED_SIGNATORY',
    SUPERVISOR = 'SUPERVISOR',
    EMPLOYEES_MANAGEMENT = 'EMPLOYEES_MANAGEMENT',
    SERVICES_MANAGEMENT = 'SERVICES_MANAGEMENT',
    COID_OPENBANKING_ACCESS_MANAGEMENT = 'COID_OPENBANKING_ACCESS_MANAGEMENT',
    BILLING_ACCESS = 'BILLING_ACCESS',
    DISPUTES_ACCESS = 'DISPUTES_ACCESS'
}

